import { Button } from "./button";

type Props = {
  mode: "create" | "edit";
  isPending: boolean;
  error: string | null;
  onCancel: () => void;
};

export function FormActionButtons({ mode, isPending, error, onCancel }: Props) {
  const isCreateMode = mode === "create";

  function getSubmitLabel(): string {
    if (isPending) return isCreateMode ? "Creating..." : "Saving...";
    return isCreateMode ? "Create" : "Save";
  }

  return (
    <div className="flex items-center gap-2">
      {error && <p className="text-sm text-red-muted">{error}</p>}
      <Button variant="secondary" onClick={onCancel} disabled={isPending}>
        {isCreateMode ? "Discard" : "Cancel"}
      </Button>
      <Button type="submit" disabled={isPending}>
        {getSubmitLabel()}
      </Button>
    </div>
  );
}
